<template>
    <div id="app">
        <main-header nowtab="group"></main-header>
        <main class="adjuster">
            <div>
                <div class="render-text" v-html="parse(introText)"></div>
            </div>
        </main>
        <Footer></Footer>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue';
import Footer from '@/components/Footer.vue';
import { getSSRdata } from '../../utils/utils';

export default {
    data() {
        return {
            introText: "",
        }
    },
    async created() {
        const data = getSSRdata("group");
        this.introText = data.text;
    },
    methods: {
        /**
         * @param {string} raw
         */
        parse(raw, space = true) {
            if (!space)
                raw = raw.replace(/ /, "&nbsp;");
            return raw
                .replace(/\n<br>/g, "<br>")
                .replace(/[\n\r]/g, "<br>");
        },
    },
    components: {
        MainHeader, Footer,
    },
};
</script>

<style>
html, body {
    height: 100%;
    width: 100%;
    margin: 0;
}
body {
    background-color: #e6e6e6 !important;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    cursor: default;
}
</style>

<style lang="less" scoped>
.adjuster {
    margin: 20px auto;
    @media screen and (min-width: 1000px) {
        width: 1000px;
    }
    @media screen and (max-width: 999px) {
        width: 100%;
        padding: 0 5px;
    }
    display: flex;
    flex-direction: column;
    align-items: center;
}
.render-text {
    font-size: 16px;
    text-align: left;
    color: #444444;
    img {
        max-width: 100%;
    }
    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
        p {
            margin: 10px 0;
            line-height: 1.5;
        }
    }
    overflow-wrap: anywhere;
}
</style>
